import Button from "../Button/Button";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import { useUpdateMergeItem } from "../../hooks/useCrm";
import { useState } from "react";
import { useEffect } from "react";
import Typography from "../Typography/Typography";

export const UpdateMergeItemModal = ({ handleClose, show, item }) => {
  const [form, setForm] = useState({ IdMergeFile: null });
  const { mutateAsync } = useUpdateMergeItem();
  const handleUpdate = async (data) => {
    await mutateAsync(data);
  };
  useEffect(() => {
    setForm({ IdMergeFile: item?.IdMergeFile });
  }, [item]);

  return (
    <BootstrapModal
      modaltitle="تبدیل به پرونده اصلی"
      handleClose={handleClose}
      show={show}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <Typography>
        آیا از تبدیل این پرونده به پرونده اصلی مطمئن هستید؟
      </Typography>
      <div className="row mt-4">
        <div className="col-6">
          <Button
            bgColor="#009EF7"
            color="#fff"
            size="14px"
            onclick={() => {
              handleUpdate(form);
              handleClose();
            }}
          >
            بله
          </Button>
        </div>
        <div className="col-6">
          <Button
            bgColor="#F1416C"
            color="#fff"
            size="14px"
            onclick={() => {
              handleClose();
            }}
          >
            خیر
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};

export default UpdateMergeItemModal;
